import {useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {injectIntl} from "react-intl";

import {isIframe} from "../../misc/helpers";
import {setIframeIntegrationRequest, setIframeIntegrationResponse} from "../../actions/iframeIntegrationFunctions";
import {GROHE_POST_MESSAGES_ACTIONS} from "./iframeIntegration";
import {renderErrorPopup} from "../../api/api-popups";
import {LOOK_OVERLAYS} from "./core/constants";
import {setLookOverlayOpened} from "../../actions/lookFunctions";
import {loaderDisable} from "../ui/loaderView";

export const postMessageToParent = (postMessageData) => {
  console.log("sending postMessage to parent with data: ", postMessageData);
  if (isIframe() && window.parent) {
    return window.parent.postMessage(postMessageData, document.referrer);
  }
  return false
}

/**
 * this class reacts to all post messages from parent iframe
 **/
const LookMessaging = (props) => {

  const {setIframeIntegrationResponse, iframeIntegrationRequestType, iframeIntegrationResponseSuccess,
    setIframeIntegrationRequest, loginPostMessage, setLookOverlayOpened, iframeIntegrationResponse} = props;

  const handleIFrameMessage = (event) => {
    console.log("event received in visualizer: ", event);
    if (event && event.data && event.data.hasOwnProperty("Success")) {
      setIframeIntegrationResponse(event.data);
    }
  };

  useEffect(() => {
    if (isIframe() && window.parent) {
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if ((iframeIntegrationRequestType === GROHE_POST_MESSAGES_ACTIONS.save)
      && (typeof iframeIntegrationResponseSuccess == "boolean")) {
      loaderDisable();
      setIframeIntegrationRequest({});
      setIframeIntegrationResponse({});
      window.postMessageIsExecuting = false;
      if (iframeIntegrationResponseSuccess) {
        setLookOverlayOpened(LOOK_OVERLAYS.saveSucess);
      } else if (iframeIntegrationResponse["ErrorCode"] === "SAVE-003") {
        loginPostMessage(true);
      } else {
        renderErrorPopup(iframeIntegrationResponse["ErrorMessage"]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeIntegrationRequestType, iframeIntegrationResponseSuccess])

  return null

};

const mapStateToProps = (store) => {
  const {iframeIntegrationRequest, iframeIntegrationResponse} = store.iframeIntegrationState;
  return {
    iframeIntegrationRequestType: iframeIntegrationRequest["EventType"],
    iframeIntegrationResponseSuccess: iframeIntegrationResponse["Success"],
    iframeIntegrationResponse,
  };
};

const mapDispatchToProps = {
  setIframeIntegrationResponse,
  setIframeIntegrationRequest,
  setLookOverlayOpened,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(LookMessaging))
)
